import { createFileRoute, Outlet } from '@tanstack/react-router';
import { ensureCatalogEntries } from '../../../features/catalog/queries';
import { CatalogLinksProvider } from '../../../components/CatalogLinks';

// Layout for the dashboard catalog: switches the shared catalog components'
// internal links to /dashboard/catalog/* so browsing detail/endpoint pages stays
// inside the dashboard instead of jumping to the marketing site.
export const Route = createFileRoute('/dashboard/catalog')({
  loader: ({ context }) => ensureCatalogEntries(context.queryClient),
  component: CatalogLayout,
});

function CatalogLayout() {
  return (
    <CatalogLinksProvider base="dashboard">
      <Outlet />
    </CatalogLinksProvider>
  );
}
